module.exports = __webpack_public_path__ + "img/i4.425f8e4f.png";